import { type FetchBaseQueryError } from '@reduxjs/toolkit/query';

const isFetchBaseQueryError = (
  error: unknown,
): error is FetchBaseQueryError => {
  return typeof error === 'object' && error != null && 'status' in error;
};

const isErrorWithMessage = (error: unknown): error is { message: string } => {
  return (
    typeof error === 'object' &&
    error != null &&
    'message' in error &&
    typeof error.message === 'string'
  );
};

const getMessageFromQueryError = (error: unknown): string | null => {
  const isFetchError = isFetchBaseQueryError(error);

  if (
    isFetchError &&
    error.data &&
    typeof error.data === 'object' &&
    'message' in error.data &&
    typeof error.data.message === 'string'
  ) {
    return error.data.message;
  } else {
    return null;
  }
};

export { getMessageFromQueryError, isErrorWithMessage, isFetchBaseQueryError };
